export default {
  /**
   * 规格弹层滑到底部
   */
  specBottomShow() {
    return {
      cfrom: 5323,
      event_id: '081|034|02|077'
    }
  },
  /**
   * 规格项点击
   * @param {string} specName 规格名称
   * @param {string} specItemName 规格项名称
   */
  specItemClick({ specName, specItemName }) {
    return {
      cfrom: 5342,
      event_id: '081|045|01|077',
      style: specName,
      style_detail: specItemName
    }
  },
  /**
   * 套餐点击
   * @param {*} name 套餐名称
   */
  suiteClick({ id, name }) {
    return {
      cfrom: 5326,
      event_id: '081|035|01|077',
      id,
      name
    }
  },
  /**
   * 镭雕点击
   * @param {boolean} checked 是否选中
   * @param {*} goodtype 商品类型， 1 手机， 2 配件， 3 服务
   * @param {*} goodid skuId
   */
  laserClick({ checked, goodtype, goodid }) {
    return {
      cfrom: 5327,
      event_id: '081|036|01|077',
      checked,
      goodtype,
      goodid
    }
  },
  /**
   * 分期数点击
   * @param {number} fqNum 分期数
   */
  installmentClick(fqNum) {
    return {
      cfrom: 5328,
      enent_id: '081|037|01|077',
      num_fenqi: fqNum
    }
  },
  /**
   * 服务点击
   * @param {*} id 服务id
   * @param {*} name 服务名称
   */
  serviceClick({ id, name }) {
    return {
      cfrom: 5329,
      event_id: '081|038|01|077',
      id,
      name
    }
  },
  /**
   * 数量加减
   * @param {*} num 当前数量
   * @param {*} type 1 加， 2 减
   */
  numberClick({ num, type }) {
    return {
      cfrom: 5330,
      event_id: '081|039|01|077',
      num,
      type
    }
  }
}
